import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';

@Component({
  selector: 'app-crew-machine-matrix',
  templateUrl: './crew-machine-matrix.component.html',
  styleUrl: './crew-machine-matrix.component.css',
})
export class CrewMachineMatrixComponent implements OnInit {
  rows: any[] = [];
  staff: any[] = [];
  machines: any[] = [];
  loading = false;
  form: any = {
    staff_id: '',
    machine_id: '',
    role: 'operator',
    is_primary: false,
    effective_from: '',
    effective_to: '',
    notes: '',
  };
  filterStatus = 'active';

  constructor(private api: ApiService, private toastr: ToastrMsgService) {}

  ngOnInit(): void {
    this.api.getStaff({ keyword: '' }).subscribe({
      next: (res: any) => (this.staff = res?.data || []),
    });
    this.api.getMachineMaster().subscribe({
      next: (res: any) => (this.machines = Array.isArray(res) ? res : res?.data || []),
    });
    this.load();
  }

  load(): void {
    this.loading = true;
    this.api.listCrewMachine({ status: this.filterStatus || undefined }).subscribe({
      next: (res: any) => {
        this.rows = res?.data || [];
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        this.toastr.error(err?.error?.message || 'Failed to load assignments');
      },
    });
  }

  assign(): void {
    if (!this.form.staff_id || !this.form.machine_id) {
      this.toastr.error('Select staff and machine');
      return;
    }
    this.api.assignCrewMachine(this.form).subscribe({
      next: () => {
        this.toastr.success('Crew assigned to machine');
        this.form = { staff_id: '', machine_id: '', role: 'operator', is_primary: false, effective_from: '', effective_to: '', notes: '' };
        this.load();
      },
      error: (err) => this.toastr.error(err?.error?.message || 'Assign failed'),
    });
  }

  setPrimary(row: any): void {
    this.api.updateCrewMachine(row.id, { is_primary: true }).subscribe({
      next: () => {
        this.toastr.success('Primary operator updated');
        this.load();
      },
      error: (err) => this.toastr.error(err?.error?.message || 'Update failed'),
    });
  }

  deactivate(row: any): void {
    this.api.updateCrewMachine(row.id, { status: 'inactive' }).subscribe({
      next: () => this.load(),
      error: (err) => this.toastr.error(err?.error?.message || 'Update failed'),
    });
  }

  remove(row: any): void {
    this.api.deleteCrewMachine(row.id).subscribe({
      next: () => {
        this.toastr.success('Assignment removed');
        this.load();
      },
      error: (err) => this.toastr.error(err?.error?.message || 'Remove failed'),
    });
  }
}
